var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"last_update_component"}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm._f("i18n")('last_update')))]),_c('span',{staticClass:"date"},[_vm._v(_vm._s(_vm._f("showHour")(_vm.date.date)))]),_c('span',{staticClass:"user"},[_vm._v(_vm._s(_vm.date.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }